if (!customElements.get('product-slider')) {
    customElements.define('product-slider', class ProductSlider extends HTMLElement {
      constructor() {
        super();
    
        this.createSlider();
    
      }
    
      createSlider(){
        var slider = document.querySelector('.product__media-slider');
    
        var flkty = new Flickity( slider, {
          // options
          cellAlign: 'left',
          contain: true,
          watchCSS: true,
          arrowShape: 'm67.37 100-50-50 50-50 15.26 15.25-34.75 34.75 34.75 34.75z'
        });
      }
  
      // updateSlider(){
      //   console.log('render');
      // }
    
    })
  }